import { crud } from 'td-vue3-ui'
const root = `td-punish/taskRegistCase`
export default {
  ...crud(root)
}
